import Api from './Api';
import Configuracao from '../util/Configuracao';

class GuiaApi extends Api {
  async consultarGuiasDoLote (codLoteGuia) {
    try {
      const urlConsultarGuiasDoLote = Configuracao.getConfiguracao().urlConsultarGuiasDoLote + codLoteGuia + '/guia';
      const response = await this.fetch(urlConsultarGuiasDoLote);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarGuia (codLote, codGuia) {
    try {
      const urlConsultarGuia = Configuracao.getConfiguracao().urlConsultarGuia + codLote + '/guia/' + codGuia;
      const response = await this.fetch(urlConsultarGuia);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarDetalhesGuia (codGuia, codLoteGuia, codTipoGuia) {
    try {
      const urlConsultarDetalhesGuia = Configuracao.getConfiguracao().urlConsultarDetalhesGuia + codLoteGuia + '/guia/' + codGuia + '/tipo/' + codTipoGuia;
      const response = await this.fetch(urlConsultarDetalhesGuia);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarGuiaOriginal (codGuia, codLoteGuia) {
    try {
      const urlConsultarGuiaOriginal = Configuracao.getConfiguracao().urlConsultarGuiaOriginal + codLoteGuia + '/guia/' + codGuia + '/original';
      const response = await this.fetch(urlConsultarGuiaOriginal);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarGuiasSolicitacao (codLoteGuia, txtSenha, txtMatricula) {
    try {
      const urlConsultarGuiasSolicitacao = Configuracao.getConfiguracao().urlConsultarGuiasSolicitacao + codLoteGuia + '/guia/guias_solicitacao/' + txtSenha + '/' + txtMatricula;
      const response = await this.fetch(urlConsultarGuiasSolicitacao);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarGuiasDuplicadas (codGuia, codLoteGuia, elemento) {
    try {
      const urlConsultarGuiasDuplicadas = Configuracao.getConfiguracao().urlConsultarGuiasDuplicadas + codLoteGuia + '/guia/' + codGuia + '/guias_duplicidade/' + elemento.id + '/tipo/' + elemento.tipoElementoGuia + '/item/' + elemento.codItemTabela;
      const result = await this.fetch(urlConsultarGuiasDuplicadas);
      return result.data;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerAuditoria (codLote, codGuia) {
    const url = Configuracao.getConfiguracao().urlDesfazerAuditoriaGuia;
    const result = this.fetch(url, 'POST', { codLote: codLote, codGuia: codGuia }, { 'content-type': 'application/json' });
    return result;
  }

  async glosar (codLote, codGuia) {
    const url = Configuracao.getConfiguracao().urlGlosarGuia;
    const result = this.fetch(url, 'POST', { codLote: codLote, codGuia: codGuia }, { 'content-type': 'application/json' });
    return result;
  }

  async auditarAutomaticamente (codLote, codGuia) {
    const url = Configuracao.getConfiguracao().urlAuditarAutomaticamenteGuia;
    const result = this.fetch(url, 'POST', { codLote: codLote, codGuia: codGuia }, { 'content-type': 'application/json' });
    return result;
  }

  async autorizar (codLote, codGuia) {
    const url = Configuracao.getConfiguracao().urlAutorizarGuia;
    const result = this.fetch(url, 'POST', { codLote: codLote, codGuia: codGuia }, { 'content-type': 'application/json' });
    return result;
  }
  async salvarParecerAuditoria (codLote, codGuia, txtParecer) {
    const urlSalvarParecerAuditoria = Configuracao.getConfiguracao().urlSalvarParecerAuditoria + codLote + '/guia/' + codGuia + '/txt_parecer_auditoria';
    const result = this.fetch(urlSalvarParecerAuditoria, 'PUT', txtParecer, { 'content-type': 'application/json' });
    return result;
  }
  async salvarMotivoGlosaGuia (guia) {
    const urlSalvarMotivoGlosaGuia = Configuracao.getConfiguracao().urlSalvarMotivoGlosaGuia;
    const result = this.fetch(urlSalvarMotivoGlosaGuia, 'POST', guia, { 'content-type': 'application/json' });
    return result;
  }
  async salvarGuiaConferida (codLote, codGuia, indConferida) {
    const urlSalvarGuiaConferida = Configuracao.getConfiguracao().urlSalvarGuiaConferida + codLote + '/guia/' + codGuia + '/salvar_guia_conferida/' + indConferida;
    const result = this.fetch(urlSalvarGuiaConferida, 'PUT');
    return result;
  }
}

export default GuiaApi;
